// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-nav[data-v-402264f8]{position:fixed;bottom:0;z-index:2}.details-mobile[data-v-402264f8]{height:100%;min-height:100vh;z-index:1}@media screen and (min-width:768px) and (max-width:991px){.page_registro._registro[data-v-402264f8]{width:100%}}", ""]);
// Exports
module.exports = exports;
